import { useState } from 'react';
import {
  Box, Typography, IconButton, TextField, Button, MenuItem, Grid
} from '@mui/material';
import dayjs from 'dayjs';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';

const avpuOptions = ['Alert', 'V', 'P', 'U'];

export default function ObservationViewerEditor({ data = [], onChange, isScenario = false }) {
  const [editingIndex, setEditingIndex] = useState(null);
  const [editForm, setEditForm] = useState({});
  const ACCENT_BORDER = '#60A5FA';

  const handleEdit = (index) => {
    setEditingIndex(index);
    setEditForm({ ...data[index] });
  };

  const handleCancel = () => {
    setEditingIndex(null);
    setEditForm({});
  };

  const handleSave = () => {
    const updated = [...data];
    updated[editingIndex] = editForm;
    onChange(updated);
    handleCancel();
  };

  const handleRemove = (index) => {
    const updated = data.filter((_, i) => i !== index);
    onChange(updated);
  };

  const updateField = (field, value) => {
    setEditForm((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <Box mt={4} style={{width:'80%', marginTop:'0px'}}>
      <h3 style={{textAlign:'center'}}>Existing Entries</h3>
      {data.map((entry, index) => (
        <Box
          key={index}
          sx={{
            border: `1px solid ${ACCENT_BORDER}`,
            borderRadius: 2,
            padding: 2,
            marginBottom: 2,
            backgroundColor: editingIndex === index ? '#f9f9f9' : '#fff'
          }}
        >
          {editingIndex === index ? (
            <>
              <Grid container spacing={2}>
                {isScenario ? (
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Name"
                      value={editForm.name ?? ''}
                      onChange={(e) => updateField('name', e.target.value)}
                      fullWidth
                    />
                  </Grid>
                ) : (
                  <Grid item xs={12} sm={4}>
                    <TextField
                      label="Date/Time"
                      type="datetime-local"
                      value={
                        editForm.datetime
                          ? dayjs(editForm.datetime).format('YYYY-MM-DDTHH:mm')
                          : ''
                      }
                      onChange={(e) =>
                        updateField('datetime', new Date(e.target.value).toISOString())
                      }
                      fullWidth
                    />
                  </Grid>
                )}

                {['rr', 'spo2', 'sbp', 'pulse', 'temp', 'o2', 'device'].map((key) => (
                  <Grid item xs={6} sm={2} key={key}>
                    <TextField
                      label={key.toUpperCase()}
                      value={editForm[key] ?? ''}
                      onChange={(e) => updateField(key, e.target.value)}
                      fullWidth
                    />
                  </Grid>
                ))}
                <Grid item xs={6} sm={2}>
                  <TextField
                    label="AVPU"
                    select
                    value={editForm.avpu ?? ''}
                    onChange={(e) => updateField('avpu', e.target.value)}
                    fullWidth
                  >
                    {avpuOptions.map((opt) => (
                      <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>

              <Box mt={2} display="flex" justifyContent="flex-end" gap={1}>
                <Button variant="contained" onClick={handleSave} startIcon={<SaveIcon />}>Save</Button>
                <Button variant="outlined" onClick={handleCancel} startIcon={<CancelIcon />}>Cancel</Button>
              </Box>
            </>
          ) : (
            <>
              <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', fontWeight:'bold'}}>
              <Typography style={{fontWeight:'bold'}}>
                {entry.time_offset} {entry.time_offset_unit} ago
              </Typography>
              <div>
              <IconButton onClick={() => handleEdit(index)}><EditIcon /></IconButton>
              <IconButton onClick={() => handleRemove(index)}><DeleteIcon /></IconButton>
              </div>
              </div>

              <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
              <Typography variant="body2" sx={{ mt: 1 }}>
                  RR: {entry.rr ?? '-'}, Sats: {entry.spo2 ?? '-'}, O₂: {entry.o2 ?? '-'} {entry.device ?? ''}, SBP: {entry.sbp ?? '-'}, Pulse: {entry.pulse ?? '-'}, Temp: {entry.temp ?? '-'}, AVPU: {entry.avpu ?? '-'}
              </Typography>
              
              </div>
            </>
          )}
        </Box>
      ))}
    </Box>
  );
}
